import { TagViewModel } from './../../models/view-models/tag-models/tag-view.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../../app.settings';
import { BehaviorSubject, Observable } from 'rxjs';
import { MonitorTagPluralAssignmentModel } from '../../models/view-models/monitor-models/monitor-tag-plural-assignment.model';
import { MonitorKey } from '../../models/view-models/monitor-models/monitor-key.type';

@Injectable({ providedIn: 'root' })
export class TagService {

  public tagCollectionChanged = new BehaviorSubject<TagViewModel[]>([]);
  private endpoint: string;

  constructor(
    private readonly http: HttpClient,
    private readonly config: AppConfig) {
    this.endpoint = `${this.config.getConfig('api')}MonitorTags`;
  }

  getAllTags(): Observable<TagViewModel[]> {
    return this.http.get<TagViewModel[]>(this.endpoint,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  getOneTag(id: number): Observable<TagViewModel> {
    const urlFull = `${this.endpoint}/${id}`;
    return this.http.get<TagViewModel>(urlFull,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  getMonitorTagByMonitorKey(monitorKey: MonitorKey): Observable<TagViewModel[]> {
    const urlFull = `${this.endpoint}/${monitorKey.MachinePhysicalAddress}/${monitorKey.MonitorHandler}`;

    return this.http.get<TagViewModel[]>(urlFull,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  createTag(model: TagViewModel): Observable<TagViewModel> {
    return this.http.post<TagViewModel>(`${this.endpoint}`, model,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  updateTag(model: TagViewModel): Observable<TagViewModel> {
    return this.http.put<TagViewModel>(this.endpoint, model,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  deleteTag(id: number): Observable<void> {
    const urlFull = `${this.endpoint}/${id}`;
    return this.http.delete<void>(urlFull,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  assignTagToPlural(assignments: MonitorTagPluralAssignmentModel): Observable<void> {
    const url = `${this.endpoint}/assign-to-monitor`;
    return this.http.post<void>(url, assignments, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  unAssignMonitorTagFromMonitor(assignments: MonitorTagPluralAssignmentModel): Observable<void> {
    const url = `${this.endpoint}/unassign-from-monitor`;
    return this.http.post<void>(url, assignments, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  public getAllTagsInfo(): void {
    this.getAllTags().subscribe((allTags: TagViewModel[]) => this.tagCollectionChanged.next(allTags));
  }
}
